import { useStaticQuery, graphql } from 'gatsby';

const getProjectData = () => {
  const {
    strapiProject: { footer, menu, cookie },
  } = useStaticQuery(graphql`
    query projectQuery {
      strapiProject {
        cookie
        menu {
          navBar {
            links {
              title
              route
              is_new
              id
            }
            menu {
              menu_link {
                id
                is_dropdown
                is_new
                label
                route
                
              }
              logo {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      placeholder: NONE
                      formats: [AUTO, WEBP]
                      quality: 100
                    )
                  }
                }
              }
            }
            logo {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    placeholder: NONE
                    formats: [AUTO, WEBP]
                    quality: 100
                  )
                }
              }
            }
          }
        }
        footer {
          footer {
            description
            id
            actionLink {
              id
              route
              logo {
                url
                localFile {
                  url
                }
              }
            }
            section {
              title
              id
              link {
                id
                label
                route
                image {
                  url
                  localFile {
                    url
                  }
                }
              }
            }
            logo {
              url
              localFile {
                url
              }
            }
            site_below {
              copyright
              id
              links {
                id
                label
                route
              }
            }
          }
          name
        }
      }
    }
  `);

  return { footer, menu, cookie };
};

export default getProjectData;
